import script from "./Diashow.vue?vue&type=script&setup=true&lang=js"
export * from "./Diashow.vue?vue&type=script&setup=true&lang=js"

import "./Diashow.vue?vue&type=style&index=0&id=1be4899a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1be4899a"]])

export default __exports__